import { PROFILE_CONSTANTS } from "@/modules/Profile/constants/ProfileConstants";
import { FORM_CONSTANTS } from "@/shared/constants/FormConstants";

export const LIST_ITEM_CONSTANTS = {
  REFRESH_DATA: "refreshData",
  EDIT_DATA: "editData",
  DELETE_DATA: "deleteData",
  DELETE_MODAL: {
    TITLE: "Eliminar ",
    TEXT: "Ingrese la razón por la cual va a eliminar "
  },
  MAX_CARD_ACTIONS: 3,
  HANDLER_OPERATION: "handleOperation",
  ACTIONS: {
    editData: FORM_CONSTANTS.BUTTON.EDIT,
    deleteData: FORM_CONSTANTS.BUTTON.DELETE,
    viewData: FORM_CONSTANTS.BUTTON.VIEW,
    profile: PROFILE_CONSTANTS.SEE_PROFILE,
    disableData: FORM_CONSTANTS.ENABLE_DISABLE,
    activeData: FORM_CONSTANTS.ACTIVE_TEXT,
    deactivatedData: FORM_CONSTANTS.DEACTIVED_TEXT,
    listenAudio: FORM_CONSTANTS.BUTTON.LISTEN,
    duplicateData: FORM_CONSTANTS.BUTTON.DUPLICATE
  } as { [key: string]: string },
  ICONS: {
    editData: "mdi-pencil-outline",
    deleteData: "mdi-delete-outline",
    viewData: "mdi-eye",
    profile: "mdi-account-outline",
    disableData: "mdi-cancel",
    activeData: "mdi-check-circle-outline",
    deactivatedData: "mdi-cancel",
    listenAudio: "mdi-ear-hearing",
    duplicateData: "mdi-content-duplicate"
  } as { [key: string]: string }
};
